import ToolCard from '../../components/ToolCard';
import { useState, useEffect } from "react";
import apiClient from '../../utils/request';
import './index.css';
import '../../commoncss/toolcommon.css';

// 请求拦截器（保持不变）
apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

export default function Home2() {
  const [tools, setTools] = useState([]);
  const [loading, setLoading] = useState(true);

  // 获取所有工具（组件挂载时执行一次）
  useEffect(() => {
    const source = apiClient.CancelToken?.source?.() || { cancel: () => {} };
    const fetchAllTools = async () => {
      setLoading(true);
      try {
        // 请根据实际后端接口调整 URL，例如 '/tools' 或 '/alltools'
        const response = await apiClient.get("/catetool/findallcatetools", {
          cancelToken: source.token
        });
        setTools(response.data);
      } catch (thrown) {
        if (apiClient.isCancel?.(thrown)) {
          console.log("Request canceled", thrown.message);
        } else {
          console.error(thrown);
        }
      } finally {
        setLoading(false);
      }
    };
    fetchAllTools();

    return () => source.cancel?.("All tools request canceled.");
  }, []);

  const handleVisit = (tool) => {
    //console.log(`访问了 ${tool.name}`);
    // 可扩展跳转逻辑
  };

  return (
    <div className='page-parent'>
      <div className="home-container">
        {/* 仅保留主内容区，去除侧边栏 */}
        <main className="main-content" style={{ width: '100%' }}>
          {/* 标题栏：固定显示“全部工具” */}
          <div className="main-header">
            <h2 className="main-title">全部工具</h2>
            {!loading && <span className="main-count">共 {tools.length} 个工具</span>}
          </div>

          {/* 加载中：骨架屏 */}
          {loading ? (
            <div className="tool-list" aria-busy="true">
              {Array.from({ length: 8 }).map((_, i) => (
                <div key={i} className="tool-card-skeleton" />
              ))}
            </div>
          ) : tools.length > 0 ? (
            /* 工具卡片列表 */
            <div className="tool-list">
              {tools.map((item, index) => (
                <ToolCard
                  key={item.id || item.toolCode || item.code || index}
                  tool={item}
                  onVisit={handleVisit}
                />
              ))}
            </div>
          ) : (
            /* 空状态 */
            <div className="tool-empty">
              <p>暂无工具</p>
            </div>
          )}
        </main>
      </div>
    </div>
  );
}